// src/stores/counterStore.js
import { makeAutoObservable } from "mobx";

class AnalyticalWritingStore {
  greModuleResponses=[];
  greSections = [];
  moduleId = "";
  selectedSectionId = null;
  selectedSectionName = "";
  questionType = "";
  currentSectionId = "";
  currentModuleQuestions = [];
  questionTypeId="";
  questionCategory = [];
  selectedQuestionId = "";
  selectedQuestionType="";
  payload = {
    title: "",
    passage: "",
    description: "",
    question: "",
    instructions: "",
    idealAnswer: "",
    explanation: "",
    notes: [],
    images: {},
    quantity: [{}],
    blanks: [
      {
        blankName: "",
        answers: [],
      },
    ],
    selectInPassageAnswer:"",
    moduleId: "",
    sectionId: "",
    questionContentTypeId: "",
    questionContentDomainId: "",
    questionTypeId: "",
    questionDifficultyLevel: 0,
    additionalProps: { },
  };
  currentClickedQuestion={};
  updatedDataGre = []

  constructor() {
    makeAutoObservable(this);
    this.loadPersistedData();
  }

  setQuestionType(data) {
    this.questionType = data;
  }
  setQuestionTypes = (questionTypes) => {
    this.questionType = questionTypes;
  };
  setGreSections(data) {
    this.greSections = data;
  }
  setSelectedQuestionId = (id) => {
    this.selectedQuestionId = id;
  };
  setSelectedQuestionType(data){
    this.selectedQuestionType = data;
  }
  setModuleId(data) {
    this.moduleId = data;
  }
  setSelectedSectionName(name) {
    this.selectedSectionName = name;
  }
  setQuestionCategory  (questionTypes) {
    this.questionCategory = questionTypes;
  };
  setUpdatedDataGre(data){
    this.updatedDataGre = data
  }
  setCurrentsectionId(data) {
    this.currentSectionId = data;
  }
  setQuestionTypeId(data){
    this.questionTypeId = data
  }
  setCurrentModuleQuestions (moduleQns)  {
    this.currentModuleQuestions = moduleQns;
  };
  setPayload (data){
    this.payload = data;
  }

  setSelectedSectionId(id) {
    this.selectedSectionId = id;
  }

  setGreModuleResponses(data){
    this.greModuleResponses = data;
  }
  setCurrentClickedQuestion = (item) => {
    this.currentClickedQuestion = item;
  }
  savePersistedData() {
    localStorage.setItem(
      "selectedSection",
      JSON.stringify({
        id: this.selectedSectionId,
        name: this.selectedSectionName,
      })
    );
  }

  // Method to load persisted data from localStorage
  loadPersistedData() {
    const persistedData = localStorage.getItem("selectedSection");
    if (persistedData) {
      const parsedData = JSON.parse(persistedData);
      this.selectedSectionId = parsedData.id;
      this.selectedSectionName = parsedData.name;
    }
  }
}

const analyticalWritingStore = new AnalyticalWritingStore();
export default analyticalWritingStore;
